export default __webpack_public_path__ + "static/media/shelf.c397c751.svg";